(function () {
  var SLOT_SELECTOR = "[data-qk-klarna-osm]";
  var AMOUNT_SELECTOR = "[data-qk-klarna-installment-amount]";
  var INIT_ATTR = "data-qk-klarna-osm-init";

  function formatInstallmentAmount(priceCents) {
    var cents = Math.max(0, Math.round(Number(priceCents || 0) / 3));
    var whole = Math.floor(cents / 100);
    var decimals = String(cents % 100).padStart(2, "0");

    return whole.toLocaleString("ro-RO") + "," + decimals + "lei";
  }

  function updateInstallmentAmount(slot, priceCents) {
    var amountElement = slot.querySelector(AMOUNT_SELECTOR);

    if (amountElement) {
      amountElement.textContent = formatInstallmentAmount(priceCents);
    }
  }

  function initSlot(slot) {
    if (slot.hasAttribute(INIT_ATTR)) {
      return;
    }

    slot.setAttribute(INIT_ATTR, "true");

    var formId = slot.getAttribute("data-form-id");
    var form = formId ? document.getElementById(formId) : null;

    if (!form) {
      return;
    }

    form.addEventListener("variant:change", function (event) {
      if (event.detail && event.detail.variant) {
        updateInstallmentAmount(slot, event.detail.variant.price);
      }
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var slots = scope.querySelectorAll(SLOT_SELECTOR);

    for (var index = 0; index < slots.length; index += 1) {
      initSlot(slots[index]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
